import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/Order';

import Order from './Order';
import {resetStore} from "../../../../redux/modules/login";

const ms2p = (state) => {
    return {
        ...state.order,
    };
};

const md2p = { ...actions, resetStore };

export default connect(ms2p, md2p)(Order);
